import { IEditActionSource } from '../types';
import { Action } from '@wix/component-protocol/schema';
import { EditActionsStore } from '../editActionsStore';

export class SystemActionSource extends IEditActionSource<string> {
  getDefinitions() {
    return Object.fromEntries(
      EditActionsStore.getSystemActionNames().map((name) => [name, {}]),
    ) as Partial<Record<string, Action>>;
  }
}
